import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import toast from 'react-hot-toast';
import { omitKeys } from 'state/helpers';

export const exportToExcel = async (data, fileName = "Excel.xlsx", omitFields = []) => {
    try {
        if (!data || data.length === 0) {
            toast.error("No data available to export.");
            return;
        }

        const processedData = omitKeys(data, omitFields);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        // Add headers dynamically based on keys in the first object of the data array
        if (processedData.length > 0) {
            const headers = ['No.', ...Object.keys(processedData[0]).filter(key => key !== '_id')];
            worksheet.addRow(headers);

            // Apply header styles
            headers.forEach((header, index) => {
                const cell = worksheet.getCell(1, index + 1);
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFFFCC" }, // Light yellow
                };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
            });
        }

        // Add data rows, replacing '_id' with row number
        processedData.forEach((row, index) => {
            const rowData = [index + 1, ...Object.entries(row).filter(([key]) => key !== '_id').map(([, value]) => value)];
            worksheet.addRow(rowData);
        });

        // Apply text wrapping to all cells
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
            });
        });

        // Adjust column widths based on the content
        worksheet.columns.forEach((column) => {
            column.width = column.header
                ? Math.max(
                    column.header.length,
                    ...column.values.map((v) => (v ? v.toString().length : 30))
                ) + 2 // Add padding
                : 30;
        });

        // Generate timestamp for filename if not provided
        const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "").slice(0, 14); // YYYYMMDDHHMMSS
        const finalFileName = fileName.includes(".xlsx") ? fileName : `${fileName}_${timestamp}.xlsx`;

        // Generate and save the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), finalFileName);
    } catch (error) {
        toast.error("Failed to export to Excel!");
        throw error; // Re-throw for caller to handle if needed
    }
};

